import React, { useEffect, useState } from "react";
import Button from "../../Common/Buttons/Buttons";
import { useRouter } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useSetPasswordMutation } from "@/Redux/apis/auth";
import Image from "next/image";
import { useUpdatePasswordMutation } from "../../../Redux/apis/reps";
import { toast } from "react-toastify";
const ChangePasswordPopup = ({
  onClose
}) => {
  const users = useSelector(state => state?.userData?.userData?.user);
  const {
    register: updatePasswordForm,
    handleSubmit: handleUpdatePasswordForm,
    formState: {
      errors: updatePasswordError
    },
    watch
  } = useForm();
  const [updatePassword, updatePasswordResponse] = useUpdatePasswordMutation();
  const [changePassword, setChangePassword] = useState({
    password: "",
    confirmPassword: ""
  });
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const onChangeHandler = e => {
    const {
      name,
      value
    } = e.target;
    setChangePassword({
      ...changePassword,
      [name]: value
    });
  };
  const id = users._id;
  const HandleUpdatePassword = async data => {
    setLoading(true);
    try {
      data.id = users?._id;
      await updatePassword(data);
      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (updatePasswordResponse.isLoading) {
      setLoading(false);
    } else if (!updatePasswordResponse.isLoading && updatePasswordResponse.isSuccess) {
      setLoading(false);
      toast.success("password set successfully");
      onClose();
    } else if (updatePasswordResponse.isError && updatePasswordResponse.status === "rejected" && updatePasswordResponse?.error?.status === 400) {
      toast.error(updatePasswordResponse?.error?.data?.message);
      setLoading(false);
    }
  }, [updatePasswordResponse]);
  const newPasswordValue = watch("password");
  const [currentPasswordVisible, setCurrentPasswordVisible] = useState(false);
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const toggleCurrentPasswordVisibility = () => {
    setCurrentPasswordVisible(!currentPasswordVisible);
  };
  const toggleNewPasswordVisibility = () => {
    setNewPasswordVisible(!newPasswordVisible);
  };
  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };
  return <>
      <div className="fixed inset-0 popup-bg z-50 flex justify-center items-end sm:items-center">
        <div className="w-full sm:max-w-[383px] h-full sm:h-auto bg-white rounded-none sm:rounded-2xl shadow border border-neutral-200 flex flex-col overflow-hidden">
          {/* Header */}
          <div className="flex justify-between w-full border-b border-neutral-200 p-4 sm:p-4 pb-2 flex-shrink-0">
            <div className="text-[#2E0B34] text-[16px] font-semibold font-poppins">
              Update your password
            </div>
            <div onClick={onClose} className="w-6 h-6 cursor-pointer relative bg-white flex-shrink-0">
              <svg fillRule="evenodd" clipRule="evenodd" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" fill="white" />
                <path fillRule="evenodd" clipRule="evenodd" d="M5.00049 17.5864C4.60999 17.977 4.61005 18.6101 5.00061 19.0006C5.39117 19.3911 6.02433 19.3911 6.41482 19.0005L12.0001 13.4143L17.5858 19C17.9763 19.3905 18.6095 19.3905 19 19C19.3905 18.6095 19.3905 17.9763 19 17.5858L13.4142 12L18.9996 6.41359C19.39 6.02303 19.39 5.38987 18.9994 4.99938C18.6089 4.60888 17.9757 4.60894 17.5852 4.9995L11.9999 10.5858L6.41414 4.99998C6.02362 4.60946 5.39045 4.60946 4.99993 4.99998C4.6094 5.39051 4.6094 6.02367 4.99993 6.4142L10.5859 12.0001L5.00049 17.5864Z" fill="#8E8E8E" />
              </svg>
            </div>
          </div>

          <form onSubmit={handleUpdatePasswordForm(HandleUpdatePassword)} className="w-full flex-1 flex flex-col overflow-hidden">
            {/* Scrollable content */}
            <div className="flex-1 overflow-y-auto px-4 sm:px-4">
              <div className="text-[#8E8E8E] text-[13px] sm:text-[14px] font-normal py-2 font-poppins">
                Uploading your recent picture as profile image is recommended
              </div>

              {/* Current Password */}
              <div className="pt-1">
                <div className="text-[13px] sm:text-[14px] text-[#8E8E8E] font-medium font-poppins">
                  Current Password
                </div>
                <div className="border border-[#CACACA] flex items-center gap-2 rounded-lg px-2 w-full mt-2">
                  <input type={currentPasswordVisible ? "text" : "password"} placeholder="Enter Current Password" className="w-full py-2.5 placeholder:font-light border-none outline-none rounded-lg text-sm" {...updatePasswordForm("currentPassword", {
                  required: "Current password is required"
                })} />
                  <Image src={currentPasswordVisible ? "/Images/showEye.svg" : "/Images/hideEye.svg"} alt={currentPasswordVisible ? "Hide password" : "Show password"} onClick={toggleCurrentPasswordVisibility} width={14} height={14} className="cursor-pointer" />
                </div>
                {updatePasswordError.currentPassword && <span className="text-red-500 text-xs sm:text-sm">{updatePasswordError.currentPassword.message}</span>}
              </div>

              {/* New Password */}
              <div className="pt-3">
                <div className="text-[13px] sm:text-[14px] text-[#8E8E8E] font-medium font-poppins">
                  New Password
                </div>
                <div className="border border-[#CACACA] flex items-center gap-2 rounded-lg px-2 w-full mt-2">
                  <input type={newPasswordVisible ? "text" : "password"} placeholder="Enter New Password" className="w-full py-2.5 placeholder:font-light border-none outline-none rounded-lg text-sm" {...updatePasswordForm("password", {
                  required: "New password is required",
                  pattern: {
                    value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/,
                    message: "Password must include at least one letter, one number, and one special character, and be at least 6 characters long"
                  }
                })} />
                  <Image src={newPasswordVisible ? "/Images/showEye.svg" : "/Images/hideEye.svg"} alt={newPasswordVisible ? "Hide password" : "Show password"} onClick={toggleNewPasswordVisibility} width={14} height={14} className="cursor-pointer" />
                </div>
                {updatePasswordError.password && <span className="text-red-500 text-xs sm:text-sm">{updatePasswordError.password.message}</span>}
              </div>

              {/* Repeat New Password */}
              <div className="pt-3 pb-4">
                <div className="text-[13px] sm:text-[14px] text-[#8E8E8E] font-medium font-poppins">
                  Repeat New Password
                </div>
                <div className="border border-[#CACACA] flex items-center gap-2 rounded-lg px-2 w-full mt-2">
                  <input type={confirmPasswordVisible ? "text" : "password"} placeholder="Repeat New Password" className="w-full py-2.5 placeholder:font-light border-none outline-none rounded-lg text-sm" {...updatePasswordForm("confirmPassword", {
                  required: "Please confirm your new password",
                  validate: value_0 => value_0 === newPasswordValue || "Passwords do not match"
                })} />
                  <Image src={confirmPasswordVisible ? "/Images/showEye.svg" : "/Images/hideEye.svg"} alt={confirmPasswordVisible ? "Hide password" : "Show password"} onClick={toggleConfirmPasswordVisibility} width={14} height={14} className="cursor-pointer" />
                </div>
                {updatePasswordError.confirmPassword && <span className="text-red-500 text-xs sm:text-sm">{updatePasswordError.confirmPassword.message}</span>}
              </div>
            </div>

            {/* Fixed footer button */}
            <div className="flex-shrink-0 px-4 sm:px-4 pt-4 pb-4 sm:pb-4 border-t border-gray-100 w-full">
              <button type="submit" className="w-full py-2.5 rounded-[10px] cursor-pointer justify-center items-center gap-2.5 flex text-white text-sm font-medium font-poppins bg-[#354EF0]" disabled={loading}>
                {loading ? "Loading..." : "Save Changes"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>;
};
export default ChangePasswordPopup;